import Vue from 'vue';
import VueRouter from 'vue-router';
import MainCategory from '../views/MainCategory.vue';
import SubCategory from '../views/SubCategory.vue';
import Merchant from '../views/Merchant.vue';
import Cities from '../views/Cities.vue';
import Logs from '../views/Logs.vue';
import Users from '../views/Users.vue';
import Ad from '../views/Ad.vue';
import { getToken } from '../api';

Vue.use(VueRouter);

const routes = [
  { path: '/', redirect: '/users' },
  { path: '/cities', component: Cities },
  { path: '/main', component: MainCategory },
  { path: '/sub', component: SubCategory },
  { path: '/merchants', component: Merchant },
  { path: '/ads', component: Ad },
  { path: '/users', component: Users },
  { path: '/logs', component: Logs },
];

const routerBase = process.env.VUE_APP_BASE_PATH || '/';
const router = new VueRouter({
  mode: 'history',
  base: routerBase === '/' ? '/' : routerBase,
  routes,
});

router.beforeEach((to, from, next) => {
  if (!getToken()) {
    next();
  } else {
    next();
  }
});

export default router;
